import { CsvHeaderModel } from '../../../models/CsvHeader';

export const PRODUCT_CSV_HEADER: CsvHeaderModel[] = [
  {
    label: 'id',
    key: 'id',
  },
  {
    label: 'itemcode',
    key: 'itemcode',
  },
  {
    label: 'zone',
    key: 'zone',
  },
  {
    label: 'recommend',
    key: 'recommend',
  },
  {
    label: 'newProduct',
    key: 'newProduct',
  },
  {
    label: 'salesAmount',
    key: 'sales_amount',
  },
  {
    label: 'productNameEn',
    key: 'productNameEn',
  },
  {
    label: 'productNameLa',
    key: 'productNameLa',
  },
  {
    label: 'barcodes',
    key: 'barcodes',
  },
  {
    label: 'pack size',
    key: 'packType',
  },
  {
    label: 'price',
    key: 'price',
  },
  {
    label: 'active',
    key: 'isActive',
  },
  {
    label: 'Stock',
    key: 'quantity',
  },
];
